@if (
  {
    row: columnData | async,
  };
  as $
) {
  @if ($.row && $.row.clt_pay_token_status) {
    <span>{{ getClientPaymentTokenStatus($.row.clt_pay_token_status) }} </span>
  }
}
